import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  return (
    <div className="flex justify-center">
      <div className="flex flex-col items-center">
        <div>
          <h1 className="text-3xl pt-8">Experiment 8 : Decryption of plaintext using Twofish algorithm</h1>
        </div>
        <div className="pt-10">
          <h1>Instructions</h1>
        </div>
        <div class="instruction-box">
          <p>
          <strong>Welcome to Experiment 8 : Decryption of plaintext using Twofish algorithm Simulator!</strong>
          <br /><br />
→ Input: 1. Students input a 16-character plain text message.
<br /><br />

→ Conversion:
<br />&nbsp;&nbsp; 2. The entered plain text message is internally converted to the corresponding 128-bit binary representation.
<br />&nbsp;&nbsp; 3. The binary representation is further converted to its hexa-decimal representation.
<br /><br />

→ Twofish Decryption:
<br />&nbsp;&nbsp; 4. The hexa-decimal message is fed into the standard 16-round Twofish algorithm.
<br />&nbsp;&nbsp; 5. Each round involves a series of predefined calculations.
<br /><br />

→ Visualization
<br />&nbsp;&nbsp; 6. Hexa-decimal data is represented as a matrix for better understanding.
<br />&nbsp;&nbsp; 7. Each step of the decryption process is clearly visualized to aid student comprehension.
<br /><br />

→ User Interaction: 8. Students can click provided buttons to view the internal workings of the decryption process for each round.
<br /><br />

→ Intermediate Result
<br />&nbsp;&nbsp; 9. Participants will be asked to calculate the (k+1)th intermediate result after the first k rounds.
<br />&nbsp;&nbsp; 10. If the student provides the correct answer, the remainder of the simulation will be shown.

<br /><br />

<strong>Note:</strong> A technical journal proves invaluable in this journey. Document insights, challenges, and questions to ensure a comprehensive grasp on AES key generation intricacies. Dive in and immerse yourself in the world of AES.
          </p>
        </div>
        <div class="button-holder">
          <div class="next-button" onClick={firstpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
